import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import daTranslation from "./locales/da/translation.json";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            da: {
                translation: daTranslation
            }
        },

        lng: "da",
        fallbackLng: "da",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;